import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { CSS } from '@dnd-kit/utilities';
import { Input } from 'reactstrap';
import { useSortable } from '@dnd-kit/sortable';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import images from 'assets/images';
import INITIAL_VALUE from 'constants/initialValue';

import styles from './CardImage.module.scss';

function CardImage(props) {
  const {
    isDraggingProps,

    item,

    onSelectImage,
    onPreviewImage,

    style: customStyle,

    className,
  } = props;

  const {
    isDragging: isDraggingLib,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
    ...customStyle,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={classNames(styles.CardImage,
        isDraggingProps && styles.CardDraggingProp,
        isDraggingLib && styles.CardDraggingLib,
        className)}
    >
      <Input
        type="checkbox"
        checked={!!item.checked}
        name={item.id}
        className={styles.CardCheckbox}
        onChange={onSelectImage}
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
      />

      <div className={styles.CardOverlay}>
        <div
          className={styles.ButtonZoom}
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            onPreviewImage?.(item.image);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              onPreviewImage?.(item.image);
            }
          }}
        >
          <img src={images.controlCameraIcon.default} alt="Icon Camera" />
          <span>Xem</span>
        </div>
      </div>

      <LazyLoadImage
        alt="preview"
        effect="blur"
        src={item.image}
        wrapperClassName={styles.ImageWrap}
        className={styles.Image}
      />
    </div>
  );
}

CardImage.propTypes = {
  isDraggingProps: PropTypes.bool,

  item: PropTypes.instanceOf(Object),

  onSelectImage: PropTypes.func,
  onPreviewImage: PropTypes.func,

  style: PropTypes.instanceOf(Object),

  className: PropTypes.string,
};

CardImage.defaultProps = {
  isDraggingProps: false,

  item: INITIAL_VALUE.OBJECT,

  onSelectImage: INITIAL_VALUE.FUNCTION,
  onPreviewImage: INITIAL_VALUE.FUNCTION,

  style: INITIAL_VALUE.OBJECT,

  className: '',
};

export default React.memo(CardImage);
